export default {
  fetch: {
    error: 'an error occurred',
  },
  option: {
    nodata: 'unknown user',
  },
}
